import { Injectable } from '@angular/core';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  public alert(message: string) {
    return of(alert(message));
  }
}
